

<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.faqs' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text"> {{ 'MENU.DASHBOARD.faqs_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage" class="mr-2">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2"
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div> -->
        </div>
  
      <ngx-datatable 
        [rows]="pages"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
        [messages]="messages">

  <ngx-datatable-column
    name="{{ 'MENU.DASHBOARD.id' | translate }}"
    prop="id"
    [width]="20">
  </ngx-datatable-column>

  <!-- Question Arabic -->
  <ngx-datatable-column
    name="{{ 'MENU.DASHBOARD.question_ar' | translate }}"
    prop="question_ar"
    [width]="200">
    <ng-template ngx-datatable-cell-template let-row="row">
      <!-- {{ row.question_ar | truncate:20 }} -->
                         {{ (row.question_ar || '').slice(0, 20) }}{{ (row.question_ar || '').length > 20 ? '...' : '' }}

    </ng-template>
  </ngx-datatable-column>

  <!-- Question English -->
  <ngx-datatable-column
    name="{{ 'MENU.DASHBOARD.question_en' | translate }}"
    prop="question_en"
    [width]="200">
    <ng-template ngx-datatable-cell-template let-row="row">
      <!-- {{ row.question_en | truncate:20 }} -->
                   {{ (row.question_en || '').slice(0, 20) }}{{ (row.question_en || '').length > 20 ? '...' : '' }}

    </ng-template>
  </ngx-datatable-column>

  <!-- Answer Arabic -->
  <ngx-datatable-column
    name="{{ 'MENU.DASHBOARD.answer_ar' | translate }}"
    prop="answer_ar"
    [width]="250">
    <ng-template ngx-datatable-cell-template let-row="row">
      <!-- {{ row.answer_ar | truncate:20 }} -->
             {{ (row.answer_ar || '').slice(0, 20) }}{{ (row.answer_ar || '').length > 20 ? '...' : '' }}

    </ng-template>
  </ngx-datatable-column>

  <!-- Answer English -->
  <ngx-datatable-column
    name="{{ 'MENU.DASHBOARD.answer_en' | translate }}"
    prop="answer_en"
    [width]="250">
    <ng-template ngx-datatable-cell-template let-row="row">
      <!-- {{ row.answer_en | truncate:20 }} -->
       {{ (row.answer_en || '').slice(0, 20) }}{{ (row.answer_en || '').length > 20 ? '...' : '' }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Actions Column -->
  <ngx-datatable-column 
    name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" 
    prop="actions" 
    [flexGrow]="1" 
    [sortable]="false">
    <ng-template ngx-datatable-cell-template let-row="row">
      <div class="d-flex align-items-center">
        <div ngbDropdown container="body" class="btn-group">
          <button
            ngbDropdownToggle
            type="button"
            class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
            [id]="'dropdownActions_' + row.id">
            <i data-feather="more-vertical"></i>
          </button>

          <div
            ngbDropdownMenu
            class="dropdown-menu dropdown-menu-right"
            [attr.aria-labelledby]="'dropdownActions_' + row.id">

            <!-- Edit Button -->
            <button
              class="dropdown-item w-100"
              ngbDropdownItem
              (click)="editProduct(row.id)">
              <i data-feather="edit" class="mr-50 mx-2"></i>
              {{ 'MENU.DASHBOARD.investor_edit' | translate }}
            </button>

            <button
              class="dropdown-item text-danger w-100"
              ngbDropdownItem
              (click)="confirmDelete(row.id)">
              <i data-feather="trash" class="mr-50 mx-2"></i>
              {{ 'MENU.DASHBOARD.investor_delete' | translate }}
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </ngx-datatable-column>

</ngx-datatable>
       
      </section>
    </div>
  </div>
  


<!-- <div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="about-section">
      <div class="row">
        <div class="col-md-6 col-12 mb-3">
          <div class="card shadow-sm border-0 rounded-3">
            <div class="card-header bg-light">
              <h4 class="card-title text-primary mb-0">   {{ 'MENU.DASHBOARD.faq_title' | translate }}</h4>
            </div>
            <div class="card-body">
                
              <input
                type="text"
                class="form-control mt-2"
                [(ngModel)]="faqs[0].question"
            [placeholder]="'MENU.DASHBOARD.faq_question_placeholder' | translate"
              />

              <textarea
                class="form-control mt-3"
                [(ngModel)]="faqs[0].answer"
                rows="8"
            [placeholder]="'MENU.DASHBOARD.faq_answer_placeholder' | translate"
              ></textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-4">
        <button class="btn btn-primary px-5 py-2 save-btn" (click)="saveAll()">
                    {{ 'MENU.DASHBOARD.faq_save_button' | translate }}
 
        </button>
      </div>
    </section>
  </div>
</div> -->
